import React from 'react';
import { Link } from 'react-router-dom';
import Scanner from '../components/Scanner';

/**
 * Read-only preview: the same discovery, with no session and no writes. Exists
 * so the result can be checked before trusting the app with an account.
 */
export default function Preview() {
  return (
    <div className="app-container">
      <header className="navbar">
        <div className="navbar-logo">Follower</div>
        <div className="navbar-actions">
          <Link className="button-link" to="/login">
            Sign in
          </Link>
        </div>
      </header>

      <main className="main-container">
        <h1 className="lead">Look before signing in. The scan is read-only.</h1>
        <p className="prose">
          This preview reads public repositories exactly as the signed-in version does, but it
          cannot write anything. Following needs your own account.
        </p>
        <Scanner readOnly />
      </main>

      <footer className="footer">Reads public repositories · nothing is written in preview</footer>
    </div>
  );
}
